import * as yup from "yup";


export const emailValidation = yup.string().required("Email is required").email("Invalid email address")
export const passwordValidation =yup.string()
.min(8, 'Password must be at least 8 characters')
.required('Password is required')
export const cpasswordValidation =yup.string()
.min(8, 'Password must be at least 8 characters')
.required('Password is required')
export const email_otpValidation =yup.string()
.min(4, 'Otp must be 4 characters')
.required('Otp is required')

export const firstNameValidation = yup.string().required("First Name is required")
export const phoneValidation = yup.string().required("Phone no. is required")
export const cityValidation = yup.string().required("City is required")
export const provinceValidation = yup.string().required("Province is required")
export const lastNameValidation = yup.string().required("last Name is required")
export const countryValidation = yup.string().required("Country is required")
export const genderValidation = yup.string().required("Gender is required")
export const termsValidation = yup.string().required('You must agree to the terms')